function initMapSwitching() {
  document.querySelectorAll('.google-map').forEach(sec => {
    if (sec.dataset.mapInit) return; sec.dataset.mapInit = 1;
    const btns = sec.querySelectorAll('.faq__list--item__button'),
          maps = sec.querySelectorAll('.google-map__map-item'),
          show = id => maps.forEach(m => m.classList.toggle('active', m.dataset.locationId === id));
    
    const first = sec.querySelector('.faq__list--item');
    if (first) show(first.dataset.locationId);

    btns.forEach(b => b.addEventListener('click', () => setTimeout(() => {
      const item = b.closest('.faq__list--item');
      if (item?.classList.contains('active')) show(item.dataset.locationId);
    }, 50)));
  });
}

document.addEventListener("DOMContentLoaded", initMapSwitching);
document.addEventListener("shopify:section:load", () => setTimeout(initMapSwitching, 100));